import { Component } from "react";
import i18n from '../../i18n';
import PropTypes from "prop-types";
import Select from "react-select";
import { Button, Modal, Form, Spinner } from "react-bootstrap";
import { FaFileCsv } from "react-icons/fa";
import api from "../../services/api";
import { getCurrentUser } from "../../common/utils";

class ExportCSVExcel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { value: "id", label: "ID" },
        { value: "nome", label: "Nome" },
        { value: "cpf", label: "CPF" },
        { value: "data_nascimento", label: "Data de Nascimento" },
        { value: "email", label: "Email" },
        { value: "telefone", label: "Telefone" },
        { value: "celular", label: "Celular" },
        { value: "endereco", label: "Endereco" },
        { value: "cidade", label: "Cidade" },
        { value: "uf", label: "UF" },
        { value: "programa__nome", label: "Programa" },
        { value: "cliente__nome", label: "Cliente" },
        { value: "titular__nome", label: "Titular" },
        { value: "data_criacao", label: "Data de Criacao" },
        { value: "status", label: "Status" },
      ],
      selectedColumns: [
        { value: "id", label: "ID" },
        { value: "nome", label: "Nome" },
        { value: "cpf", label: "CPF" },
        { value: "data_nascimento", label: "Data de Nascimento" },
        { value: "email", label: "Email" },
        { value: "programa__nome", label: "Programa" },
        { value: "data_criacao", label: "Data de Criacao" },
      ],
      exportFormat: "csv",
      showModal: false,
      allFieldsChecked: false,
      exporting: false,
    };
  }

  handleAllFieldsToggle = () => {
    const { allFieldsChecked, columns } = this.state;
    this.setState({
      allFieldsChecked: !allFieldsChecked,
      selectedColumns: !allFieldsChecked ? columns : [],
    });
  };

  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  getPayload = () => {
    const { selectedColumns, exportFormat } = this.state;
    const { filtros = {} } = this.props;
    const currentUser = getCurrentUser() || {};
    const payload = {
      columns: selectedColumns.map((col) => col.value),
      format: exportFormat,
    };

    if (filtros.busca) {
      payload.nome = filtros.busca;
    }

    if (filtros.cliente_id || currentUser.ambiente_cliente_id) {
      payload.cliente_id = filtros.cliente_id || currentUser.ambiente_cliente_id;
    }

    if (filtros.programa_id || currentUser.ambiente_programa_id) {
      payload.programa_id = filtros.programa_id || currentUser.ambiente_programa_id;
    }

    if (filtros.cadastro_teste) {
      payload.cadastro_teste = 1;
    }

    if (currentUser.tipo_usuario) {
      payload.tipo_usuario = currentUser.tipo_usuario;
    }

    return payload;
  };

  getFileName = (headers, exportFormat) => {
    const disposition =
      headers?.["content-disposition"] || headers?.["Content-Disposition"];
    const match = disposition?.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);

    if (match?.[1]) {
      return decodeURIComponent(match[1].replace(/"/g, "").trim());
    }

    return exportFormat === "csv"
      ? "relatorio_relacao_pacientes.csv"
      : "relatorio_relacao_pacientes.xlsx";
  };

  downloadFile = (response, exportFormat) => {
    const contentType =
      response.headers?.["content-type"] ||
      (exportFormat === "csv"
        ? "text/csv;charset=utf-8;"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");

    const blob = new Blob([response.data], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", this.getFileName(response.headers, exportFormat));
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
  };

  handleExport = async () => {
    const { selectedColumns, exportFormat, exporting } = this.state;

    if (selectedColumns.length === 0) {
      alert("Por favor, selecione ao menos uma coluna.");
      return;
    }

    if (exporting) {
      return;
    }

    this.setState({ exporting: true });

    try {
      const response = await api.post(
        "/export-beneficiarios-data/",
        this.getPayload(),
        { responseType: "blob" }
      );

      this.downloadFile(response, exportFormat);
      this.toggleModal();
    } catch (error) {
      console.error(`Erro ao exportar ${exportFormat.toUpperCase()}:`, error);
      alert(`Nao foi possivel exportar ${exportFormat.toUpperCase()}. Tente novamente.`);
    } finally {
      this.setState({ exporting: false });
    }
  };

  render() {
    const {
      showModal,
      columns,
      selectedColumns,
      exportFormat,
      allFieldsChecked,
      exporting,
    } = this.state;

    return (
      <>
        <Button variant="light" size="sm" onClick={this.toggleModal} disabled={exporting}>
          <FaFileCsv /> {i18n.t('common:export.csvExcel')}
        </Button>

        <Modal show={showModal} onHide={exporting ? undefined : this.toggleModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>{i18n.t('common:export.csvExcel')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{i18n.t('common:export.selectColumns')}</p>
            <div className="mb-3">
              <input
                type="checkbox"
                id="all-fields-pacientes-csv"
                checked={allFieldsChecked}
                onChange={this.handleAllFieldsToggle}
                disabled={exporting}
              />
              <label htmlFor="all-fields-pacientes-csv" className="ms-2">
                {i18n.t('common:export.allFields')}
              </label>
            </div>
            <Select
              options={columns}
              isMulti
              isDisabled={exporting}
              onChange={(selected) =>
                this.setState({
                  selectedColumns: selected || [],
                  allFieldsChecked: !!selected && selected.length === columns.length,
                })
              }
              value={selectedColumns}
              placeholder={i18n.t('common:export.columnsPlaceholder')}
              className="mb-3"
            />
            <Form>
              <Form.Group>
                <Form.Label>{i18n.t('common:export.format')}</Form.Label>
                <Form.Check
                  type="radio"
                  label="CSV"
                  name="exportFormat"
                  value="csv"
                  checked={exportFormat === "csv"}
                  disabled={exporting}
                  onChange={(e) => this.setState({ exportFormat: e.target.value })}
                />
                <Form.Check
                  type="radio"
                  label="Excel"
                  name="exportFormat"
                  value="excel"
                  checked={exportFormat === "excel"}
                  disabled={exporting}
                  onChange={(e) => this.setState({ exportFormat: e.target.value })}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.toggleModal} disabled={exporting}>
              {i18n.t('common:button.cancel')}
            </Button>
            <Button variant="primary" onClick={this.handleExport} disabled={exporting}>
              {exporting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  {i18n.t('common:export.exporting')}
                </>
              ) : (
                i18n.t('common:export.export')
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

ExportCSVExcel.propTypes = {
  filtros: PropTypes.shape({
    busca: PropTypes.string,
    cliente_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    programa_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cadastro_teste: PropTypes.bool,
  }),
};

export default ExportCSVExcel;
